import { eLayoutType, RoutesService } from '@abpdz/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eAccountRouteNames } from '../enums/route-names';

export const ACCOUNT_ROUTE_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

export function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/account/manage-profile',
        name: eAccountRouteNames.ManageProfile,
        layout: eLayoutType.account,
        order: 3,
      },
    ]);
  };
}
